import { z } from "zod/v4";

import { OfferProductDtoSchema } from "../../../dtos/offer-products";
import { OfferDtoSchema } from "../../../dtos/offers";
import { CreateShippingDiscountDtoSchema } from "../../../dtos/shipping-discount";

export const PutOfferRequestPathParamSchema = z.object({
  offerId: z.uuid(),
  variationId: z.uuid(),
});

export type PutOfferRequestPathParamType = z.infer<
  typeof PutOfferRequestPathParamSchema
>;

export const PutOfferRequestBodySchema = z.object({
  offer: OfferDtoSchema,
  offerProducts: OfferProductDtoSchema.array(),
  shippingDiscount: CreateShippingDiscountDtoSchema.optional(),
});

export type PutOfferRequestBodyType = z.infer<typeof PutOfferRequestBodySchema>;

export const PutOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type PutOfferResponseBodyType = z.infer<
  typeof PutOfferResponseBodySchema
>;
